import { getBaseDefaultPhotoUrl, getBasePlaceholderImageUrl, isExperienceProduct, isPackageProduct } from "common";
import { Product, ProductReference } from "types";
import { xolaUri } from "../api/xolaUri";
import { isScheduled as isScheduledExperience } from "./Experience";
import { queryClient } from "@/api/queryClient";

const apiRoot = xolaUri;
export const getPlaceholderImageUrl = (size = "medium") => {
    const url = getBasePlaceholderImageUrl(size);
    return `${apiRoot}${url}`;
};

export const getDefaultPhotoUrl = (product: Product | ProductReference, size = "medium") => {
    if (!product?.id) {
        return getPlaceholderImageUrl(size);
    }

    if (!size.endsWith("_square")) {
        size += "_square";
    }

    const url = getBaseDefaultPhotoUrl(product, size);
    return `${apiRoot}/api${url}`;
};

export const isScheduled = (product: Product) => {
    if (isPackageProduct(product)) {
        // Packages can't be created for unscheduled experiences
        return true;
    }

    if (isExperienceProduct(product)) {
        return isScheduledExperience(product);
    }

    return false;
};

export const getProductFromQueryCache = <T extends Product = Product>(productId: ID) => {
    return queryClient.getQueryData<T>(["products", productId]);
};
